import React, {Component} from 'react';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import './App.css';
import Home from './components/Home'
import {Switch, Redirect, Route, withRouter, HashRouter} from 'react-router-dom';
import { getCurrentUser } from './util/ApiUtils';
import Account from './components/Account';
import Backup from './components/admin/Backup';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import ForgotPassword from './components/ForgotPassword';
import MainDecorator from './components/MainDecorator';
import { t, setLanguage } from './i18n';
import {ACCESS_TOKEN} from "./Constants";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import ContextOfOrganisation from "./components/contextOfOrganisation/ContextOfOrganisation";
import Operation from "./components/operation/Operation";
import Support from "./components/support/Support";
import Leadership from "./components/leadership/Leadership";
import Planning from "./components/planning/Planning";
import Performance from "./components/performance/Performance";
import SearchResults from "./components/common/SearchResults";
import Admin from "./components/admin/Admin";
import AdminDeleteClient from "./components/admin/AdminDeleteClient";
import AdminMigrateClient from "./components/admin/AdminMigrateClient";
import Profile from "./components/Profile";
import ProjectManagement from "./components/projectManagement/ProjectManagement";
import Flowcharts2 from "./components/flowchart/Flowcharts2";
import AdminResetPassword from "./components/admin/AdminResetPassword";

const theme = createTheme({
    root: {
        flexGrow: 1,
    },
    palette: {
        primary: { 500: '#337ab7' },
        secondary: { A400: '#336b87'},
    },
});

// Ensure any notification uses the currently stored UI language (prefer account language stored in localStorage)
// This wraps the NotificationManager methods to re-apply the persisted language before rendering the toast.
(function wrapNotificationManager() {
    try {
        const origSuccess = NotificationManager.success;
        const origError = NotificationManager.error;
        const origInfo = NotificationManager.info;
        const origWarning = NotificationManager.warning;
        function applyPersistedLang() {
            try {
                if (typeof window !== 'undefined') {
                    const lang = localStorage.getItem('lang');
                    if (lang) {
                        try { setLanguage(lang); } catch (e) { /* ignore */ }
                    }
                }
            } catch (e) { /* ignore */ }
        }
        NotificationManager.success = function(title, message, timeout) {
            applyPersistedLang();
            // Try to translate literal English titles/messages back to keys when possible
            try { title = require('./i18n').translateMaybe(title); } catch (e) { /* ignore */ }
            try { message = require('./i18n').translateMaybe(message); } catch (e) { /* ignore */ }
            return origSuccess.apply(NotificationManager, [title, message, timeout]);
        };
        NotificationManager.error = function(title, message, timeout) {
            applyPersistedLang();
            try { title = require('./i18n').translateMaybe(title); } catch (e) { /* ignore */ }
            try { message = require('./i18n').translateMaybe(message); } catch (e) { /* ignore */ }
            return origError.apply(NotificationManager, [title, message, timeout]);
        };
        NotificationManager.info = function(title, message, timeout) {
            applyPersistedLang();
            try { title = require('./i18n').translateMaybe(title); } catch (e) { /* ignore */ }
            try { message = require('./i18n').translateMaybe(message); } catch (e) { /* ignore */ }
            return origInfo.apply(NotificationManager, [title, message, timeout]);
        };
        NotificationManager.warning = function(title, message, timeout) {
            applyPersistedLang();
            try { title = require('./i18n').translateMaybe(title); } catch (e) { /* ignore */ }
            try { message = require('./i18n').translateMaybe(message); } catch (e) { /* ignore */ }
            return origWarning.apply(NotificationManager, [title, message, timeout]);
        };
    } catch (e) {
        // ignore if NotificationManager not available or already wrapped
    }
})();

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            isAuthenticated: false,
            isLoading: false,
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.loadCurrentUser = this.loadCurrentUser.bind(this);
        this.handleTAndC = this.handleTAndC.bind(this);
        this.handleLogin = this.handleLogin.bind(this);

        /*notification.config({
            placement: 'topRight',
            top: 70,
            duration: 3,
        });*/
    }

    loadCurrentUser(showLoginNotification = false) {
        this.setState({
            isLoading: true
        });
        getCurrentUser()
            .then(response => {
                // If the server provides a language for the user, lock the UI to that language
                try {
                    if (response && response.language) {
                        setLanguage(response.language);
                    }
                } catch (e) {
                    // ignore
                }
                this.setState({
                    currentUser: response,
                    isAuthenticated: true,
                    isLoading: false
                }, () => {
                    window.FS.identify(response.id, {
                        displayName : response.email,
                        email : response.username
                    }
                );
                    // show login success AFTER language has been applied
                    if (showLoginNotification) {
                        NotificationManager.success(t('app.notifications.success'), t('app.login.success'));
                    }
                });
            }).catch(error => {
            this.setState({
                isLoading: false
            });
        });
    }

    componentDidMount() {
        this.loadCurrentUser();
    }

    handleLogout(redirectTo="/", notificationType="success", description=t('app.logout.success')) {
        localStorage.removeItem(ACCESS_TOKEN);

        this.setState({
            currentUser: null,
            isAuthenticated: false
        });

        this.props.history.push(redirectTo);

        NotificationManager.success(t('app.notifications.success'), description);
    }

    handleTAndC(user) {
        // Ensure UI locks to the user's account language before showing messages
        try {
            if (user && user.language) setLanguage(user.language);
        } catch (e) {}
        NotificationManager.success(t('app.notifications.success'), t('app.tandc.accepted'), 5000);
        this.setState({
            currentUser: user,
            isAuthenticated: true,
            isLoading: false
        });
        this.props.history.push("/");
        //window.location.reload();
    }

    handleLogin() {
        // Load current user and then show login notification after language is applied
        this.loadCurrentUser(true);
        localStorage.setItem("boundUserId", "");
        this.props.history.push("/");
    }

    render() {
        return (
            <div>
                <MuiThemeProvider theme={theme}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                <Home currentUser={this.state.currentUser}/>
                            </MainDecorator>}
                        />
                        <Route
                            exact
                            path="/sign-in"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                <SignIn onLogin={this.handleLogin} {...this.props}/>
                            </MainDecorator>}
                        />
                        <Route
                            exact path="/sign-up"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} {...this.props}>
                                <SignUp/>
                            </MainDecorator>}
                        />
                        <Route
                            exact
                            path="/forgot-password"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                <ForgotPassword/>
                            </MainDecorator>}
                        />
                        <Route
                            path="/account"
                            render={() =>
                                (<MainDecorator isAuthenticated={this.state.isAuthenticated}
                                                currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC}
                                                onLogout={this.handleLogout} {...this.props}>
                                    {<Account currentUser={this.state.currentUser}/>}
                                </MainDecorator>)
                            }
                        />
                        <Route
                            path="/backup"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Backup currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/profile"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Profile currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/context-of-organisation"
                            render={() =>
                                (<MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                    {<ContextOfOrganisation currentUser={this.state.currentUser}/>}
                                </MainDecorator>)
                            }
                        />
                        <Route
                            path="/leadership"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Leadership currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/flowcharts"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Flowcharts2 currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/planning"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Planning currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/project-management"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<ProjectManagement currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/support"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Support currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/operation"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Operation currentUser={this.state.currentUser} isAuthenticated={this.state.isAuthenticated}/>}
                            </MainDecorator>}
                        />
                        <Route
                            path="/performance"
                            render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                {<Performance currentUser={this.state.currentUser}/>}
                            </MainDecorator>}
                        />
                        <Route path="/search-results"
                               render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                   {<SearchResults currentUser={this.state.currentUser}/>}
                               </MainDecorator>}
                        />
                        <Route path="/admin/new-client"
                               render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                   {<Admin currentUser={this.state.currentUser}/>}
                               </MainDecorator>}
                        />
                        <Route path="/admin/delete-client"
                               render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                   {<AdminDeleteClient currentUser={this.state.currentUser}/>}
                               </MainDecorator>}
                        />
                        <Route path="/admin/migrate-client"
                               render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                   {<AdminMigrateClient currentUser={this.state.currentUser}/>}
                               </MainDecorator>}
                        />
                        <Route path="/admin/reset-client-password"
                               render={() => <MainDecorator isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} onAcceptTC={this.handleTAndC} onLogout={this.handleLogout} {...this.props}>
                                   {<AdminResetPassword currentUser={this.state.currentUser}/>}
                               </MainDecorator>}
                        />
                    </Switch>
                    <NotificationContainer/>
                </MuiThemeProvider>
            </div>
        );
    }
}

export default withRouter(App);
